import { stringify } from 'qs';

const updatePageNumber = query => {
  if (window.history.pushState) {
    const path = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(stringify(query));
    window.history.replaceState({
      path
    }, '', path);
  }
};

export default updatePageNumber;